import React from 'react';

export default function Page404() {
	const goHome = () => (window.location.pathname = '/')

	return (
		<section className="section is-large allsection">
			<div className="container has-text-centered">
				<div className="columns is-centered">
					<div className="column is-7">
						<h1 className="title is-1 has-text-white">404</h1>
						<p className="subtitle is-3 has-text-white">Page introuvable</p>
						<p>On dirait que vous êtes perdu... </p>
					</div>
				</div>
				<button className="button is-primary" onClick={goHome.bind()}>
					Retour à la maison
				</button>
			</div>
		</section>
	);
}
